const deleteAlarm = function(alarmID, fn) {

  const init = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': 'Basic '+btoa('myapiuser:123456'),
    }
  };

  fetch(`/api/alarms/${alarmID}`, init)
    .then(response => {
      return response.json();
    }).then(json => {
      fn(json);
    }).catch(function(err) {
      console.log('parsing failed', err);
    });
}

export {
  deleteAlarm
};



// WEBPACK FOOTER //
// ./src/requests/deleteAlarm.js